// import React, { useEffect, useRef, useState } from "react";

// const Billingabout = () => {
//   const imageRef = useRef(null);
//   const textRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setIsVisible(true);
//           }
//         });
//       },
//       { threshold: 0.2 }
//     );

//     if (imageRef.current) observer.observe(imageRef.current);
//     if (textRef.current) observer.observe(textRef.current);

//     return () => {
//       if (imageRef.current) observer.unobserve(imageRef.current);
//       if (textRef.current) observer.unobserve(textRef.current);
//     };
//   }, []);

//   return (
//     <div className="industrial-container">
//       <style>
//         {`
//           .industrial-container {
//             display: flex;
//             flex-direction: row;
//             justify-content: space-between;
//             align-items: center;
//             padding: 40px 5%;
//             background-color: white;
//             flex-wrap: wrap;
//           }
//           .industrial-text {
//             width: 50%;
//             padding-left: 40px;
//             text-align: left;
//           }
//           .industrial-title {
//             font-size: 32px;
//             font-weight: bold;
//             margin-bottom: 20px;
//             color: black;
//             letter-spacing:0px;
//           }
//           .industrial-desc {
//             font-size: 16px;
//             line-height: 1.6;
//             margin-bottom: 15px;
//             text-align: justify;
//             color: black;
//           }
//           .industrial-image-section {
//             width: 45%;
//             text-align: center;
//           }
//           .industrial-image {
//             width: 100%;
//             max-width: 700px;
//             height: auto;
//             border-radius: 8px;
//           }

//           /* Animation styles */
//           .slide-in-left {
//             opacity: 0;
//             transform: translateX(-50px);
//             transition: all 1s ease-in-out;
//           }
//           .slide-in-right {
//             opacity: 0;
//             transform: translateX(50px);
//             transition: all 1s ease-in-out;
//           }
//           .visible {
//             opacity: 1;
//             transform: translateX(0);
//           }

//           /* Responsive */
//           @media (max-width: 1024px) {
//             .industrial-title {
//               font-size: 28px;
//             }
//             .industrial-desc {
//               font-size: 15px;
//             }
//           }
//           @media (max-width: 768px) {
//             .industrial-container {
//               flex-direction: column;
//               padding: 20px;
//             }
//             .industrial-text {
//               width: 100%;
//               padding-left: 0;
//               order: 2;
//             }
//             .industrial-image-section {
//               width: 100%;
//               order: 1;
//               margin-bottom: 30px;
//             }
//             .industrial-title {
//               font-size: 26px;
//               text-align: center;
//             }
//             .industrial-desc {
//               font-size: 14px;
//               text-align: left;
//             }
//           }
//           @media (max-width: 480px) {
//             .industrial-title {
//               font-size: 22px;
//             }
//             .industrial-desc {
//               font-size: 13px;
//             }
//           }
//         `}
//       </style>

//       {/* Image Section */}
//       <div
//         ref={imageRef}
//         className={`industrial-image-section slide-in-left ${
//           isVisible ? "visible" : ""
//         }`}
//       >
//         <img
//           src="/image/Billing-System.webp"
//           alt="Industrial Automation"
//           className="industrial-image"
//         />
//       </div>

//       {/* Text Section */}
//       <div
//         ref={textRef}
//         className={`industrial-text slide-in-right ${
//           isVisible ? "visible" : ""
//         }`}
//       >
//         <h2 className="industrial-title">
//           Leaders in Smart Billing & Automated Payment Solutions
//         </h2>
//         <p className="industrial-desc">
//           For businesses handling high-volume transactions, our Billing
//           Automation Platform ensures accuracy, speed, and compliance in every
//           invoice and payment process. Workflows and modules are fully
//           customizable to meet your unique financial and regulatory
//           requirements.
//         </p>
//         <p className="industrial-desc">
//           The platform seamlessly integrates with all major Enterprise Resource
//           Planning (ERP) systems, accounting software, and Customer Relationship
//           Management (CRM) tools. As a result, it becomes a core part of your
//           organization’s financial ecosystem.
//         </p>
//         <p className="industrial-desc">
//           Our billing system comes with built-in templates, automated tax
//           calculations, and real-time reporting — ready to use from day one!
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Billingabout;





import React, { useEffect, useRef, useState } from "react";

const Billingabout = () => {
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (imageRef.current) observer.observe(imageRef.current);
    if (textRef.current) observer.observe(textRef.current);

    return () => {
      if (imageRef.current) observer.unobserve(imageRef.current);
      if (textRef.current) observer.unobserve(textRef.current);
    };
  }, []);

  return (
    <div className="industrial-container">
      <style>
        {`
          .industrial-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 40px;
            background-color: white;
            flex-wrap: wrap;
            max-width: 1200px;
            margin: 20px auto;
            border-radius:10px;
          }
          .industrial-text {
            width: 50%;
            padding-left: 40px;
            text-align: left;
          }
          .industrial-title {
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 20px;
            color: black;
            letter-spacing: 0px;
          }
          .industrial-desc {
            font-size: 16px;
            line-height: 1.6;
            margin-bottom: 15px;
            text-align: justify;
            color: black;
          }
          .industrial-image-section {
            width: 45%;
            text-align: center;
          }
          .industrial-image {
            width: 100%;
            max-width: 500px; /* Reduced image size */
            height: auto;
            border-radius: 8px;
          }

          /* Animation styles */
          .slide-in-left {
            opacity: 0;
            transform: translateX(-50px);
            transition: all 1s ease-in-out;
          }
          .slide-in-right {
            opacity: 0;
            transform: translateX(50px);
            transition: all 1s ease-in-out;
          }
          .visible {
            opacity: 1;
            transform: translateX(0);
          }

          /* Responsive */
          @media (max-width: 1024px) {
            .industrial-title {
              font-size: 28px;
            }
            .industrial-desc {
              font-size: 15px;
            }
          }
          @media (max-width: 768px) {
            .industrial-container {
              flex-direction: column;
              padding: 20px;
            }
            .industrial-text {
              width: 100%;
              padding-left: 0;
              order: 2;
            }
            .industrial-image-section {
              width: 100%;
              order: 1;
              margin-bottom: 30px;
            }
            .industrial-title {
              font-size: 26px;
              text-align: center;
            }
            .industrial-desc {
              font-size: 14px;
              text-align: left;
            }
          }
          @media (max-width: 480px) {
            .industrial-title {
              font-size: 22px;
            }
            .industrial-desc {
              font-size: 13px;
            }
          }
        `}
      </style>

      {/* Image Section */}
      <div
        ref={imageRef}
        className={`industrial-image-section slide-in-left ${isVisible ? "visible" : ""}`}
      >
        <img
          src="/image/Billing-System.webp"
          alt="Billing System"
          className="industrial-image"
        />
      </div>

      {/* Text Section */}
      <div
        ref={textRef}
        className={`industrial-text slide-in-right ${isVisible ? "visible" : ""}`}
      >
        <h2 className="industrial-title">
          Leaders in Smart Billing & Automated Payment Solutions
        </h2>
        <p className="industrial-desc">
          For businesses handling high-volume transactions, our Billing
          Automation Platform ensures accuracy, speed, and compliance in every
          invoice and payment process. Workflows and modules are fully
          customizable to meet your unique financial and regulatory
          requirements.
        </p>
        <p className="industrial-desc">
          The platform seamlessly integrates with all major Enterprise Resource
          Planning (ERP) systems, accounting software, and Customer Relationship
          Management (CRM) tools. As a result, it becomes a core part of your
          organization’s financial ecosystem.
        </p>
        <p className="industrial-desc">
          Our billing system comes with built-in templates, automated tax
          calculations, and real-time reporting — ready to use from day one!
        </p>
      </div>
    </div>
  );
};

export default Billingabout;
